module.exports = __webpack_public_path__ + "img/pokemon.48743e3d.png";